import { React } from 'react'

import MainHeader from '../../components/MainHeader/MainHeader'
import MainFooter from '../../components/MainFooter/MainFooter'
import CTAButton from '../../components/CTAButton/CTAButton'

import hv_workload from '../../assets/pictures/humanvectors/workload-min-klein.webp'

import './PageNotYet.css'
import './MPageNotYet.css'
import '../../main.css'

import { lP } from '../../main.js'

export default function PageNoteYet() {

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <main className='page-body'>
                <section className='container section pagenotyet-section'>
                    <h1>Achtung Baustelle!</h1>
                    <h2>Sorry, Helferzeit ist noch nicht ganz fertig</h2>
                    <div className='infocontainer'>
                        <p>
                            Wir arbeiten aktuell noch mit Hochdruck an einigen Funktionen von Helferzeit.<br />
                            Du hast leider gerade eine dieser Baustellen entdeckt.<br />
                            Diese Seite sollte in den nächsten Tagen für dich verfügbar sein.<br />
                            Bei Fragen erreichst du uns über unseren Supportbereich<br />
                            oder alternativ per Mail an <a href="mailto:info@helferzeit.de">info@helferzeit.de</a>.<br />
                            Wir stehen dir gerne zur Seite😉
                        </p>
                        <img id="repairmanimg" src={hv_workload} alt="Human-Vektor Grafik" />
                    </div>
                    <br />
                    <CTAButton variant="primary" title="Zum Support" onclick={() => lP('https://www.helferzeit.de/support')} />
                    {/* TODO: /support bei Webstudio einrichten */}
                    <a href="/" className='backbtn'>Zur Startseite</a>
                </section>
            </main>
            <MainFooter />
        </div>
    )
}
